import type React from 'react';

import Typography from '../../Typography';

export interface StatsLabelProps {
  children: React.ReactNode;
  className?: string;
}

const StatsLabel = ({ children, className }: StatsLabelProps) => {
  if (typeof children !== 'string') return children;
  return (
    <Typography variant='body' className={className}>
      {children}
    </Typography>
  );
};

StatsLabel.displayName = 'Stats.Label';

export default StatsLabel;
